import React, { memo, useMemo, useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import moment, { Moment } from 'moment';
import RangePicker from '@/pages/home/components/RangePicker';
import InfoBubble from '@gp/components/InfoBubble';

const WEEK = 'week',
      MONTH = 'month';

type ValueType = [Moment | '', Moment | ''];
interface PropsType {
  style?: React.CSSProperties,
  className?: string,
  type: string,
  tips?: string;
  defaultValue: string,
  onChange: (
    value: string | [string, string],
    type: string,
  ) => void,
}

const OPTIONS: {[keyName: string]: any} = {
  common: {
    className: 'search-border',
    language: 'en',
    showSelectType: true,
    showShortcut: false,
    typeList: [
      WEEK,
      "month",
    ],
    autoRange: {
      limeType: 'date',
      length: 0,
    },
    isReseted: true, // 这个配置决定单周的使用
  },
  week: {},
  month: {},
};

// 因为在firefox浏览器中 用moment解析2024.10.01 这种格式的日期字符串时，会被判定为非法日期字符串，所以用这个方法转为-链接
const formatStdDateStr = (date?: string): string => {
  if (!date) return '';
  return date.replaceAll('.', '-');
};

const DateSelector: React.FC<PropsType> = (props) => {
  const {
    style,
    className,
    type,
    tips,
    defaultValue,
    onChange,
    ...remains
  } = props;

  const [dateType, setDateType] = useState<string>(WEEK);
  const [preMonthValue, setPreMonthValue] = useState<ValueType>(['', '']);
  const [preWeekValue, setPreWeekValue] = useState<ValueType>(['', '']);
  const [value, setValue] = useState<ValueType>(['', '']);

  const handleChange = useCallback((v: any, type: string)=>{
    setDateType(type);
    let realValue: any = v;
    // 没有值时用上一次的
    if (!realValue?.[0] && !realValue?.[1]) {
      if (type === MONTH && preMonthValue?.[0] && preMonthValue?.[1]) {
        realValue = preMonthValue;
      }
      if (type === WEEK && preWeekValue?.[0] && preWeekValue?.[1]) {
        realValue = preWeekValue;
      }
    }
    if (type === MONTH) {
      const value: ValueType = [realValue?.[1], realValue?.[1]];
      setValue(value);
      setPreMonthValue(value);
      onChange(
        realValue?.[1]?.format('YYYY-MM-DD') || '',
        type,
      );
    } else if (type === WEEK) {
      setValue(realValue);
      setPreWeekValue(realValue);
      onChange(
        [
          realValue?.[0]?.format('YYYY-MM-DD') || '',
          realValue?.[1]?.format('YYYY-MM-DD') || '',
        ],
        type,
      );
    }
  }, [preMonthValue, preWeekValue]);

  // 组织默认value
  useEffect(() => {
    if (!defaultValue) return;
    setDateType(type);
    if (type === MONTH && typeof defaultValue === 'string') {
      const stdDefaultValue = formatStdDateStr(defaultValue);
      if (moment(stdDefaultValue).isValid()) {
        const value: ValueType = [moment(stdDefaultValue), moment(stdDefaultValue)];
        setValue(value);
        setPreMonthValue(value);
      }
    } else if (type === WEEK && typeof defaultValue === 'string') {
      // const startDate = defaultValue?.split('-')?.[0],
      //       endDate = defaultValue?.split('-')?.[1];
      const [startDate, endDate] = defaultValue?.split('-') || [];
      const stdStartDate = formatStdDateStr(startDate);
      const stdEndDate = formatStdDateStr(endDate);
      if (moment(stdStartDate).isValid() && moment(stdEndDate).isValid()) {
        const value: ValueType = [moment(stdStartDate), moment(stdEndDate)];
        setValue(value);
        setPreWeekValue(value);
      }
    }
  }, [defaultValue]);

  return (
    <div
      {...remains}
      style={style}
      className={classnames('dbg-pipeline-projrct-filter', className)}
    >
      <InfoBubble
        className="globalpedia-modal-font14"
        placementOffset={30}
        customBubbleContent={tips}
        DomOrText={
          <RangePicker
            key={dateType}
            className={OPTIONS?.common?.className}
            typeSelectOverlayClassName="dbg-common-overlay"
            placeholder="Select Date"
            type={dateType}
            typeList={OPTIONS?.common?.typeList}
            value={value}
            onChange={handleChange}
            language={OPTIONS?.common?.language}
            showSelectType={OPTIONS?.common?.showSelectType}
            autoRange={OPTIONS?.common?.autoRange}
            showShortcut={OPTIONS?.common?.showShortcut}
            isReseted={OPTIONS?.common?.isReseted}
            // defaultValue={options.defaultValue}
            // getLocalText={()=>{}}
          />
        }
      />
    </div>
  );
};

export default memo(DateSelector);
